import React from 'react'
import { Box, Grid } from '@material-ui/core'
import { observer } from '~/common/mobx.decorator'
import ChecklistItem from '~/features/care-profile/components/checklist-item'
import { additionalInfoApplyDialogStore } from '~/components/additional-info-apply-dialog/additional-info-apply-dialog.store'
import { Typography } from '~/components/typography'
import { appStore, authStore } from '~/stores'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { ADDITION_SKILL_CHECKLIST_STATUS } from '~/common/constants'
import { checklistsStore } from '~/features/care-profile/tabs/checklists/checklists.store'
import { Button } from '~/components/button'
import { useEffectOnce } from 'react-use'

export const ChecklistsTab = observer(({ onNextTab }) => {
	const { t } = useTranslation()
	const { lookupSkillChecklistsByJob, handleSubmitStepData, initValueData } = additionalInfoApplyDialogStore
	const { getUnaLink, unaLink } = checklistsStore

	useEffectOnce(() => {
		if (authStore.id) {
			getUnaLink()
		}
	})

	return (
		<Box style={{ width: '100%' }} p={2}>
			<Typography css={[appStore.getTheme.typography.p1, { color: appStore.getTheme.colors.content.dark, fontWeight: 500 }]}>
				{t('REQUEST_SKILL_CHECKLISTS_DES')}
			</Typography>
			<Typography css={[appStore.getTheme.typography.h3, { margin: '10px 0' }]}>{t('REQUEST_SKILL_CHECKLISTS')}</Typography>
			<Box mt={3} display="flex" flexDirection="column" gridGap={8}>
				{lookupSkillChecklistsByJob?.length > 0 &&
					lookupSkillChecklistsByJob?.map((checklist) => (
						<ChecklistItem
							showUnaButton={false}
							status={checklist?.status}
							name={checklist?.name}
							completed={checklist?.status === ADDITION_SKILL_CHECKLIST_STATUS.completed}
							url={unaLink}
						/>
					))}
			</Box>
			<Grid container spacing={2}>
				<Grid style={{ marginTop: 20, marginBottom: 20 }} item justify="space-between" container>
					<Grid item xs={12} style={{ paddingLeft: 4 }}>
						<Button
							onClick={async (values) => {
								await handleSubmitStepData('checklist', initValueData)
							}}
							type="submit"
							eventId="signup_btn"
						>
							{t('COMPLETE')}
						</Button>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	)
})
